module.exports = __webpack_public_path__ + "static/assets/d3c86f1466ceed6f4ebd972e49e9c348.png";